export declare type CloudApiErrorType = Required<{
  message: string;
}>;

const isObject = (data: unknown): data is Record<string, unknown> => {
  return typeof data === 'object' && data !== null && !Array.isArray(data);
};

export const isValidApiError = (data: unknown): data is CloudApiErrorType => {
  return isObject(data) && typeof data.message === 'string';
};

export declare type FieldValidationError = {
  field: string;
  message: string;
};

export declare type MultipleFieldValidationError = {
  index: number;
  details: {
    field: string;
    message: string;
  }[];
};

export declare type FormValidationError = {
  errorType: 'error' | 'form_error' | 'multiple_form_error';
  message?: string;
  details?: FieldValidationError[];
  multipleDetails?: MultipleFieldValidationError[];
};

export const isValidFormValidationError = (
  data: unknown
): data is FormValidationError => {
  if (!isObject(data)) return false;

  const maybeFormValidationError = data as FormValidationError;
  const errorType = maybeFormValidationError.errorType;
  return (
    (errorType === 'error' ||
      errorType === 'form_error' ||
      errorType === 'multiple_form_error') &&
    (typeof maybeFormValidationError?.message === 'string' ||
      Array.isArray(maybeFormValidationError?.details) ||
      Array.isArray(maybeFormValidationError.multipleDetails))
  );
};
